<script>
    import Modal from "sv-bootstrap-modal";
    import Charts from "../charts";
    import Util from "../util";
    import GlassImage from "./GlassImage.svelte";
    import { onMount } from "svelte";
    //
    export let excelReportURL = undefined;
    export let logo = undefined;
    export let open = false;
    export let onSettings = () => {};
    export let productName = undefined;
    export let project = {};
    export let showData = false;
    export let showChartAB = false;
    export let showChartLA = false;
    export let showChartLB = false;
    //
    let charts = {};
    let compassSrc = undefined;
    let logoSrc = undefined;
    //
    $: nominal = project.Nominal || {};
    $: custom = project.Custom || {};
    $: entries = project.Entries || [];
    $: glassData = project.GlassData || [];
    $: glassImages = project.GlassImages || {};
    $: if (showChartAB || showChartLA || showChartLB) {
        loadChartsAndSet();
    }
    $: chartDisposition = { showChartAB, showChartLA, showChartLB };
    $: printPageIndexes = Object.keys(chartDisposition)
        .filter((key) => chartDisposition[key])
        .reduce((acc, key, index) => {
            acc[key] = index + 1;
            return acc;
        }, {});
    //
    async function loadChartAB({ height, print }) {
        if (!showChartAB) return;
        const model = await Charts.ab.build({ entries, nominal, custom, height });
        const chart = await Charts.load({ elementId: print ? "chartABPrint" : "chartABReport", ...model });
        return chart;
    }
    async function loadChartLA({ height, print }) {
        if (!showChartLA) return;
        const model = await Charts.al.build({ entries, nominal, custom, height });
        const chart = await Charts.load({ elementId: print ? "chartALPrint" : "chartALReport", ...model });
        return chart;
    }
    async function loadChartLB({ height, print }) {
        if (!showChartLB) return;
        const model = await Charts.bl.build({ entries, nominal, custom, height });
        const chart = await Charts.load({ elementId: print ? "chartBLPrint" : "chartBLReport", ...model });
        return chart;
    }
    async function loadCharts({ height, print = false } = {}) {
        if (!project.Nominal) return;
        try {
            Util.showProgress();
            const chartAb = await loadChartAB({ height, print });
            const chartLA = await loadChartLA({ height, print });
            const chartLB = await loadChartLB({ height, print });
            return { chartAb, chartLA, chartLB };
        } catch (error) {
            console.error(error);
        } finally {
            Util.hideProgress();
        }
    }
    async function loadChartsAndSet() {
        charts = await loadCharts();
    }
    function imgTag(chart) {
        if (!chart) return;
        return '<img src="' + chart.getImageURI() + '">';
    }
    async function onPrint() {
        // No data to print, the project is empty
        if (!charts) return;
        // Retrieve charts to show images
        const { chartAb, chartLA, chartLB } = charts;
        // Hide elements
        const elementsToHide = ["page_header", "Enclose"];
        elementsToHide.forEach((elementId) => {
            document.getElementById(elementId).style.display = "none";
        });
        // Render printable section
        // - images
        let elementChartImage = undefined;
        // - chart a*b*
        elementChartImage = document.getElementById("chartABReportImage");
        if (elementChartImage) elementChartImage.innerHTML = imgTag(chartAb);
        // - chart a*L*
        elementChartImage = document.getElementById("chartALReportImage");
        if (elementChartImage) elementChartImage.innerHTML = imgTag(chartLA);
        // - chart b*L*
        elementChartImage = document.getElementById("chartBLReportImage");
        if (elementChartImage) elementChartImage.innerHTML = imgTag(chartLB);
        // content
        const element = document.getElementById("printableReport");
        element.innerHTML = document.getElementById("reportChartsPrint").innerHTML;
        // Wait some time since the images are not fully loaded
        Util.showProgress();
        setTimeout(async () => {
            Util.hideProgress();
            window.print();
            // Restore elements
            elementsToHide.forEach((elementId) => {
                document.getElementById(elementId).style = {};
            });
            // Reset printable section
            element.innerHTML = {};
            // Render charts with default height
            await loadCharts();
        }, 1500); // 1.5 seconds
    }
    async function onPrintScaled() {
        // No data to print, the project is empty
        if (!charts) return;
        // Render printable section
        document.getElementById("reportChartsPrintScaled").style.display = "block";
        // Adjust chart height so they can be shown correctly
        const { chartAb, chartLA, chartLB } = await loadCharts({ height: 700, print: true });
        // Hide elements
        const elementsToHide = ["page_header", "Enclose"];
        elementsToHide.forEach((elementId) => {
            document.getElementById(elementId).style.display = "none";
        });
        // Render printable section
        // - logs
        const elementLogos = document.getElementById("reportLogos");
        [...document.getElementsByClassName("reportLogosPrint")].forEach((element) => {
            element.innerHTML = elementLogos.innerHTML;
        });
        // - header
        const elementHeaders = document.getElementById("reportHeader");
        [...document.getElementsByClassName("reportHeaderPrint")].forEach((element) => {
            element.innerHTML = elementHeaders.innerHTML;
        });
        // - images
        let elementChartImage = undefined;
        // - chart a*b*
        elementChartImage = document.getElementById("chartABPrint");
        if (elementChartImage) elementChartImage.innerHTML = imgTag(chartAb);
        // - chart a*L*
        elementChartImage = document.getElementById("chartALPrint");
        if (elementChartImage) elementChartImage.innerHTML = imgTag(chartLA);
        // - chart b*L*
        elementChartImage = document.getElementById("chartBLPrint");
        if (elementChartImage) elementChartImage.innerHTML = imgTag(chartLB);
        // content
        const element = document.getElementById("printableReport");
        element.innerHTML = document.getElementById("reportChartsPrintScaled").innerHTML;
        // Wait some time since the images are not fully loaded
        Util.showProgress();
        setTimeout(async () => {
            Util.hideProgress();
            window.print();
            // Restore elements
            elementsToHide.forEach((elementId) => {
                document.getElementById(elementId).style = {};
            });
            // Reset printable section
            element.innerHTML = {};
            // Render charts with default height
            await loadCharts();
            // Hide printable section
            document.getElementById("reportChartsPrintScaled").style.display = "none";
        }, 1500); // 1.5 seconds
    }
    //
    onMount(() => {
        compassSrc = (document.getElementById("imgCompass") || {}).src;
        logoSrc = (document.getElementById("imgLogo") || {}).src;
    });
</script>

<Modal bind:open dialogClasses="modal-dialog-centered modal-xl" onOpened={loadChartsAndSet}>
    <div class="modal-body" id="reportChartsPrint">
        <div id="reportLogos">
            <div class="logos">
                <div class="logo-default">
                    <img src={logoSrc} alt="Vitro" />
                </div>
                {#if logo}
                    <div style="display: flex; align-items:center">
                        <div class="logo-custom">
                            <img src={logo} alt="Custom logo" />
                        </div>
                    </div>
                {/if}
            </div>
        </div>
        <div id="reportHeader" class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div style="display: flex;">
                            <div style="flex: 1">
                                <span class="text-gray">Project:</span>
                                <span class="text-black fw-bold">{project.Name}</span>
                            </div>
                            <div style="flex: 1">
                                <span class="text-gray">Method:</span>
                                <span class="text-black fw-bold">{project.Method}</span>
                            </div>
                            <div style="flex: 1">
                                <div class="d-flex align-items-center justify-content-end">
                                    <a href={excelReportURL} id="downLoadExcelReport"
                                        title="Dowload your current project data, also dowload the data of the product configuration selected">
                                        <i class="bi bi-file-earmark-arrow-down-fill text-success fs-6" />
                                        <span>Download Excel</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div>
                            <p class="text-blue fw-bold">Product/Configuration: {productName}</p>
                        </div>
                        <br />
                        <div style="display: flex;">
                            {#if project.Type}
                                <div style="flex: 1;">
                                    <span class="text-gray">Type</span>
                                    <span class="text-black fw-bold">{project.Type || ""}</span>
                                </div>
                            {/if}
                            {#if project.Fabricator}
                                <div style="flex: 1;">
                                    <span class="text-gray">Fabricator</span>
                                    <span class="text-black fw-bold">{project.Fabricator || ""}</span>
                                </div>
                            {/if}
                            {#if project.Glazer}
                                <div style="flex: 1;">
                                    <span class="text-gray">Glazer</span>
                                    <span class="text-black fw-bold">{project.Glazer || ""} </span>
                                </div>
                            {/if}
                        </div>
                        {#if project.Details}
                            <br />
                            <div>
                                <span class="text-gray">Details</span>
                                <span class="text-black fw-bold">{project.Details || ""} </span>
                            </div>
                        {/if}

                        <br />
                        {#if showData}
                            <div class="" style="display: flex;">
                                <div class="nominal-entry" style="flex: 1;">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <td>Unit #</td>
                                                <td>L°</td>
                                                <td>a°</td>
                                                <td>b°</td>
                                                <td>ΔE*ab</td>
                                                <td>Date</td>
                                                <td>Vitro Ticket</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {#if nominal}
                                                <tr class="tr-bordered">
                                                    <td>Target 1</td>
                                                    <td>{nominal.MeasurementL || 0}</td>
                                                    <td>{nominal.MeasurementA || 0}</td>
                                                    <td>{nominal.MeasurementB || 0}</td>
                                                    <td>{nominal.MeasurementD || 0}</td>
                                                    <td />
                                                    <td />
                                                </tr>
                                            {/if}
                                            {#if project.Custom}
                                                <tr class="tr-bordered">
                                                    <td>Target 2</td>
                                                    <td>{custom.MeasurementL || ""}</td>
                                                    <td>{custom.MeasurementA || ""}</td>
                                                    <td>{custom.MeasurementB || ""}</td>
                                                    <td>{custom.MeasurementD || ""}</td>
                                                    <td />
                                                    <td />
                                                </tr>
                                            {/if}
                                            {#each entries.slice(0, 10) as entry}
                                                <tr class="tr-bordered entry">
                                                    <td>{entry.Number || ''}</td>
                                                    <td>{entry.MeasurementL}</td>
                                                    <td>{entry.MeasurementA}</td>
                                                    <td>{entry.MeasurementB}</td>
                                                    <td>{entry.MeasurementD}</td>
                                                    <td>{Util.formatDate(entry.DateDt)}</td>
                                                    <td>{entry.Ticket || ''}</td>
                                                </tr>
                                            {/each}
                                        </tbody>
                                    </table>
                                </div>
                                {#if project.Nominal}
                                    <div class="glass-image">
                                        <GlassImage {glassData} {glassImages}/>
                                    </div>
                                {/if}
                            </div>
                        {/if}
                    </div>
                </div>
            </div>
        </div>

        <div id="reportCharts">
            <div class="preview mt-4" style="display: flex; flex-wrap: wrap;">
                {#if showChartAB}
                    <div class="" style="width: 50%;">
                        <div id="chartABReport" />
                    </div>
                {/if}
                {#if showChartLA}
                    <div class="" style="width: 50%;">
                        <div id="chartALReport" />
                    </div>
                {/if}
                {#if showChartLB}
                    {#if printPageIndexes["showChartLB"] >= 3}
                        <div class="page-break-after" style="width: 100%;" />
                    {/if}
                    <div style="width: 50%;">
                        <div id="chartBLReport" />
                    </div>
                {/if}
                {#if (showChartAB || showChartLA || showChartLB) && project.Nominal}
                    <div style="width: 50%; text-align: center;">
                        <img id="imgCompassReport" src={compassSrc} alt="Color graph"/>
                    </div>
                {/if}
            </div>

            <!-- Render chart images, only shown when printing -->
            <div class="chart-image" style="width: 50%;">
                <div id="chartABReportImage" />
            </div>
            <div class="chart-image" style="width: 50%;">
                <div id="chartALReportImage" />
            </div>
            <div class="chart-image page-break-before" style="width: 50%;">
                <div id="chartBLReport" />
            </div>
        </div>

        <div id="reportChartsPrintScaled" style="display:none;">
            {#if showChartAB}
                <div class="reportLogosPrint" />
                <div class="reportHeaderPrint" />
                <div class="row">
                    <div class="col-12">
                        <div id="chartABPrint" />
                    </div>
                </div>
                <div class="page-break-after page-number" />
            {/if}
            {#if showChartLA}
                <div class="reportLogosPrint" />
                <div class="reportHeaderPrint non-f-page" />
                <div class="row">
                    <div class="col-12">
                        <div id="chartALPrint" />
                    </div>
                </div>
                <div class="page-break-after page-number" />
            {/if}
            {#if showChartLB}
                <div class="reportLogosPrint" />
                <div class="reportHeaderPrint non-f-page" />
                <div class="row">
                    <div class="col-12">
                        <div id="chartBLPrint" />
                    </div>
                </div>
                <div class="page-break-after page-number" />
            {/if}
        </div>
    </div>
    <div class="modal-footer" style="display: flex;">
        <div style="flex: 1">
            <button type="button" on:click={() => (open = false)} class="btn btn-outline-blue btn-sm"
                title="Close report preview">
                Cancel
            </button>
        </div>
        <div>
            <button type="button" on:click={onSettings} class="btn btn-outline-blue btn-sm"
                title="Open print settings window">
                <i class="pe-2 bi bi-gear" />
                <span>Customize print</span>
            </button>
            <button type="button" on:click={onPrint} class="btn btn-blue text-white btn-sm"
                title="Prepare and show the document to be printed">
                Print
            </button>
            <button type="button" on:click={onPrintScaled} class="btn btn-blue text-white btn-sm"
                title="Prepare and show the document to be printed and with enlarged charts">
                Print Scaled
            </button>
        </div>
    </div>
</Modal>

<style>
    @media print {
        #reportCharts .preview,
        #downLoadExcelReport,
        .non-f-page table .entry,
        .non-f-page .card .glass-image {
            display: none;
        }

        .non-f-page .card .nominal-entry {
            width: 100% !important;
        }

        .chart-image {
            display: block;
        }
        .page-break-before {
            page-break-before: always;
        }
        .page-break-after {
            page-break-after: always;
        }
        .page-number {
            display: flex;
            justify-content: flex-end;
        }
    }
    .chart-image {
        display: none;
    }

    a:hover {
        text-decoration: underline;
        cursor: pointer;
    }

    .btn-blue {
        background-color: #3cb1d6;
    }

    .btn-outline-blue {
        border: 2px solid black;
        background-color: white;
        border-color: #3cb1d6;
        color: #3cb1d6;
    }

    .logo-custom img {
        max-height: 100px !important;
        object-fit: cover;
    }

    .logo-default {
        padding-bottom: 15px;
    }

    .text-blue {
        color: #1f81a0;
    }

    .text-gray {
        color: gray;
    }

    .logos {
        display: flex;
        justify-content: space-between;
    }

    #imgCompassReport {
        height: 300px;
        width: 300px;
        max-width: inherit !important;
    }
</style>
